export const baseurl = 'https://sys.alnebrasmc.com/Backend/api/'
export const baseurImage = 'https://sys.alnebrasmc.com/Backend/uploads/'
